import { gql } from "@apollo/client";

export const REMOVE_MEMBER = gql`
  mutation removeMember($input: RemoveSkynetUserGroupMemberInput!) {
    rolesAndPermissions {
      removeMember(input: $input) {
        success
      }
    }
  }
`;
